var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtectionGray100(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 50 100 C 77.613281 100 100 77.613281 100 50 C 100 22.386719 77.613281 0 50 0 C 22.386719 0 0 22.386719 0 50 C 0 77.613281 22.386719 100 50 100 Z M 50 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(27.058824%,39.607843%,36.862745%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(27.058824%,39.607843%,36.862745%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 108.6625 53.8 C 108.55 53.7 108.41875 53.625 108.26875 53.5875 C 108.125 53.55 107.975 53.54375 107.825 53.58125 C 96.1125 56.2625 84.90625 49.85625 80.3125 42.45625 C 80.225 42.31875 80.10625 42.2 79.9625 42.11875 C 79.825 42.04375 79.6625 42 79.5 42 C 79.3375 42 79.18125 42.04375 79.0375 42.11875 C 78.9 42.2 78.78125 42.31875 78.69375 42.45625 C 74.1 49.85625 62.8875 56.26875 51.18125 53.5625 C 51.025 53.525 50.86875 53.525 50.71875 53.5625 C 50.56875 53.6 50.43125 53.675 50.31875 53.775 C 50.2 53.88125 50.1125 54.0125 50.0625 54.15625 C 50.00625 54.30625 49.9875 54.4625 50.00625 54.61875 L 52.39375 77.6 C 53.23125 85.875 56.10625 93.8125 60.7625 100.68125 C 65.4125 107.54375 71.7 113.125 79.0375 116.90625 C 79.16875 116.96875 79.31875 117 79.4625 117 C 79.6125 117 79.75625 116.96875 79.89375 116.90625 C 87.24375 113.13125 93.54375 107.5625 98.2125 100.69375 C 102.875 93.825 105.7625 85.8875 106.60625 77.6 L 108.99375 54.61875 C 109.0125 54.4625 108.9875 54.3125 108.925 54.16875 C 108.86875 54.025 108.78125 53.9 108.6625 53.8 Z M 104.725 77.39375 C 103.925 85.275 101.2 92.8375 96.8 99.39375 C 92.4 105.95 86.45625 111.3 79.5 114.9625 C 72.55 111.3 66.60625 105.95 62.20625 99.39375 C 57.8 92.8375 55.08125 85.275 54.28125 77.39375 L 52.05625 55.7125 C 62.26875 57.49375 73.625 52.925 79.5 44.6875 C 85.38125 52.925 96.725 57.49375 106.95 55.7125 Z M 104.725 77.39375 ",
    transform: "matrix(0.625,0,0,0.625,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,71.764706%,30.980392%)",
      fillOpacity: 1,
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(96.862745%,97.254902%,97.254902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 79.9 62.5 C 86.225 62.5 91.3 57.325 91.3 51 C 91.3 44.675 86.225 39.5 79.9 39.5 C 73.575 39.5 68.5 44.675 68.5 51 C 68.5 57.325 73.575 62.5 79.9 62.5 Z M 79.9 62.5 ",
    transform: "matrix(0.625,0,0,0.625,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionGray100);
export default __webpack_public_path__ + "static/media/protection-gray-100.6affb345.svg";
export { ForwardRef as ReactComponent };